export enum JobAction {
  DOWNLOAD_SESSION_LOGS = 'DOWNLOAD_SESSION_LOGS',
  CANCEL = 'CANCEL',
  REFRESH = 'REFRESH'
}
